import visa from "../images/paymentproviders/card_visa.svg";
import mastercard from "../images/paymentproviders/card_mastercard.svg";
import amex from "../images/paymentproviders/card_american-express.svg";
import googlePay from "../images/paymentproviders/card_google-pay.svg";
import applePay from "../images/paymentproviders/card_apple-pay.svg";
import sofort from "../images/paymentproviders/card_sofort.svg";
import giropay from "../images/paymentproviders/card_giropay.svg";
import paypal from "../images/paymentproviders/card_paypal.svg";
import invoice from "../images/paymentproviders/invoice.svg";
import twint from "../images/paymentproviders/twint.svg";

const all = {
  visa: {name: "Visa", image: visa},
  mastercard: {name: "Mastercard", image: mastercard},
  americanexpress: {name: "American Express", image: amex},
  applepay: {name: "Apple Pay", image: applePay},
  googlepay: {name: "Google Pay", image: googlePay},
  sofort: {name: "Sofort", image: sofort},
  giropay: {name: "Giropay", image: giropay},
  paypal: {name: "PayPal", image: paypal},
  invoice: {name: "Rechnung", image: invoice, hideInCheckout:true},
  twint: {name: "Twin", image: twint, hideInCheckout:false},
}

const ch = [
  all.visa, all.mastercard, all.americanexpress, all.twint, all.invoice, 
]

const de = [
  all.visa, all.mastercard, all.americanexpress, all.sofort, all.giropay, all.paypal
]

export default {
  de, ch
}